import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

import pIndex from '@/pages/index/index' //首页
import pNew from '@/pages/news-list/index' //新闻列表
import pNewsDetail from '@/pages/news-detail/index' //新闻详情
import pTeacher from '@/pages/teacher-list/index' //教师列表
import pTeacherDetail from '@/pages/teacher-detial/index' //教师详情
import pColleges from '@/pages/colleges-list/index' //院校列表
import pCollegesDetail from '@/pages/colleges-detail/index' //院校详情
import pCourse from '@/pages/course-list/index' //课程列表
import pCourseDetail from '@/pages/course-detail/index' //课程详情
import pAbout from '@/pages/about/index' //课程详情

import pLogin1 from '@/pages/login/index1' //登录页
import pLogin2 from '@/pages/login/index2' //登录页

export default new Router({
	//mode:'history',
	//base: "qxcourse",
	// 解决路由跳转后，不显示在首行
	scrollBehavior() {
		return {
			x: 0,
			y: 0
		};
	},

	routes: [{
			path: '/',
			name: 'index',
			component: pIndex,
			meta: {
				title: '首页',
				code: 1001
			}
		},
		{
			path: '/news/:firstCateId',
			name: 'news',
			component: pNew,
			meta: {
				title: '新闻动态',
				code: -1
			}
		},
		{
			path: '/newsDetail/:id',
			name: 'newsDetail',
			component: pNewsDetail,
			meta: {
				title: '新闻动态',
				code: -1
			}
		},
		{
			path: '/teacher',
			name: 'teacher',
			component: pTeacher,
			meta: {
				title: '教师团队'
			}
		},
		{
			path: '/teacherDetail/:id',
			name: 'teacherDetail',
			component: pTeacherDetail,
			meta: {
				title: '教师团队'
			}
		},
		{
			path: '/colleges',
			name: 'colleges',
			component: pColleges,
			meta: {
				title: '联盟院校',
				code: 100204
			}
		},
		{
			path: '/collegesDetail/:id',
			name: 'collegesDetail',
			component: pCollegesDetail,
			meta: {
				title: '联盟院校',
				code: 100204
			}
		},
		{
			path: '/course',
			name: 'course',
			component: pCourse,
			meta: {
				title: '课程资源',
				code: 100203
			}
		},
		{
			path: '/courseDetail/:id',
			name: 'courseDetail',
			component: pCourseDetail,
			meta: {
				title: '课程详情',
				code: 100203
			}
		},
		{
			path: '/about',
			name: 'about',
			component: pAbout,
			meta: {
				title: '关于我们',
				code: 100205
			}
		},
		{
			path: '/login1',
			name: 'login1',
			component: pLogin1,
			meta: {
				title: '登录页',
				code: ''
			}
		},
		{
			path: '/login2',
			name: 'login2',
			component: pLogin2,
			meta: {
				title: '登录页',
				code: ''
			}
		},
		{
			path: '*',
			name: 'index',
			component: pIndex,
			redirect: '/',
			code: 1001
		},
	]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
}



// WEBPACK FOOTER //
// ./src/router/index.js